module.exports = __webpack_public_path__ + "img/apr_logos_vesãoPrancheta.8b8a5c82.png";